import { RadioGroupNew, RadioButtonNew } from "@octopusdeploy/design-system-components";
import React from "react";
import { ExpandableFormSection, Note, Summary } from "~/components/form";
type CompositeDockerHubClientFeature = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function CompositeDockerHubClientFeature({ isEnabled, onChange }: CompositeDockerHubClientFeature) {
    const description = "Enable/disable Composite v1/v2 DockerHub Registry Feed support.";
    const label = "Composite DockerHub Registry Feed";
    const name = "CompositeDockerHubRegistryFeed";
    return (<ExpandableFormSection key="IsCompositeDockerHubRegistryFeedEnabled" errorKey="IsCompositeDockerHubRegistryFeedEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>

            <Note>
                <p>
                    This feature enables a new DockerHub integration mechanism which utilises both the v1 and v2 DockerHub Registry APIs to provide a fully functional feed experience.
                    <em>You should only disable this feature if you have been asked to by Octopus Support.</em>
                </p>
            </Note>
        </ExpandableFormSection>);
}
